import React, {useEffect, useState} from 'react'
import { Toast } from 'devextreme-react/toast';


export default function ToastGeneral(props) {
    const [toastConfig, setToastConfig] = useState({
        isVisible: true,
        type: props.type || 'success',
        message: props.message || '',
        displayTime: 2000,
      });
      
      useEffect(() => {
        if (props.type && props.message) {
          setToastConfig({
            isVisible: true,
            type: props.type,
            message: props.message,
            displayTime: 2000,
          });
        }
      }, [props.type, props.message]);
    
      const onHiding = () => {
        setToastConfig({
          ...toastConfig,
          isVisible: false,
        });
      }
  return (
    <Toast
    visible={toastConfig.isVisible}
    message={toastConfig.message}
    type={toastConfig.type}
    onHiding={onHiding}
    displayTime={2000}
  />
  )
}
